import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import ReqIcon from "../../../imgs/req-icon.svg";
import {
  createLot,
  trackLotEvent,
  fetchLotEvents,
} from "../../../network/fetch";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import State from "../State";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

const Step2Form = (params) => {
  const navigate = useNavigate();

  const [lotsStock, setLotsStock] = useState([...State.lots]);
  const [subLots, setSubLots] = useState([]);
  const [currentLot, setCurrentLot] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const total_steps = 4;
  const current_step = 2;
  const [tutorialStep, setTutorialStep] = useState(0);
  const [txUrl, setTxUrl] = useState("");
  const dateInputRef = useRef(null);

  useEffect(() => {
    // setLotsStock();
    State.lots = [];
  }, []);

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const supplyChainNextStep = (e) => {
    e.preventDefault();
    State.defaultClient = null;
    navigate("/supplychain/step3", {
      replace: true,
    });
    return;
  };

  // Gestion des popups tutoriels
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données (1/3)</p>
          <p>
            En tant qu’éleveur, vous avez acheté des lots de poussins que vous
            allez élever pour les transformer en volailles. Enregistrez les
            informations de ces lots dans le formulaire.
          </p>
        </>
      ),
      position: { top: "320px", left: "50%", transform: "translateX(-50%)" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">
            Sélectionnez la composition de vos lots (2/3)
          </p>{" "}
          <p>
            Ici, vous pouvez créer un nouveau lot de volailles en combinant des
            lots de poussins achetés au couvoir. Sélectionnez un ou plusieurs
            lots de poussins pour composer votre nouveau lot de volailles.
          </p>
        </>
      ),
      showArrow: true,
      position: {
        top: "470px",
        left: "55%",
        transform: "translateX(-50%)",
        width: "550px",
      },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Détection d’anomalies (3/3)</p>{" "}
          <p>
            Vous pouvez, à titre démonstratif, signaler la détection d’un
            problème lié au lot de poussins que vous avez acheté afin d’assurer
            un suivi et une traçabilité.
          </p>
        </>
      ),
      showArrow: true,
      position: {
        top: "470px",
        left: "75%",
        transform: "translateX(-50%)",
        width: "550px",
      },
      closeLabel: "hidden",
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);

  let submitedStep = [
    {
      id: "submitedStep",
      content: (
        <>
          <p className="tutorial-title">
            Vous venez d’enregistrer vos informations
          </p>
          <p>
            Vous avez enregistré les informations de votre lot de volailles.
            Elles sont désormais inscrites sur la blockchain et accessibles aux
            autres acteurs de la chaîne. Cliquez ci-dessous pour consulter les
            données partagées avec les parties prenantes.
          </p>
          <p>
            {" "}
            <b>
              Vous pouvez soumettre d’autres lots ou passer à l’étape suivante.
            </b>
          </p>
        </>
      ),
      closeLabel: "Enregistrez un nouveau lot",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e)=>{
        supplyChainNextStep(e);
      },
      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  // State for form fields
  const [formData, setFormData] = useState({
    location: "",
    lotId: "",
    quantity: "",
    feedType: "",
    buyerInfo: State.defaultClient == null ? "" : State.defaultClient,
    date: new Date().toISOString().split("T")[0],
    toggle1: false,
    toggle2: false,
    toggle3: false,
    toggle4: false,
    toggle5: false,
    toggle6: false,
  });

  let newLot = {
    lotId: "",
    quantity: 0,
    timestamp: "",
    location: "",
    buyer: State.defaultClient == null ? "" : State.defaultClient,
    subLotIds: "",
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    State.defaultClient = formData.buyerInfo;

    newLot = {
      ...newLot,
      lotId: formData.lotId,
      quantity: formData.quantity,
      timestamp: formData.convertedDate,
      location: formData.location,
      buyer: State.defaultClient,
      subLotIds: subLots.join(","),
    };

    if (isFormValid()) {
      const resp = await createLot(newLot);

      await wait(1000);
      if (resp.success) {
        const eventData = {
          ...newLot,
          eventType: "feedType",
          eventData: { feedType: formData.feedType },
        };

        const resp2 = await trackLotEvent(eventData);

        if (resp2.success === true) {
          const lotsToSend = lotsStock.filter(
            (element) => !subLots.includes(element)
          );

          setTxUrl(resp2.data.tx_uri);

          // lotsToSend.push(newLot.lotId);

          const newLotId = newLot.lotId;

          setLotsStock(lotsToSend);
          State.lots.push(newLotId);

          setCurrentLot(newLotId);

          setSubLots([]);

          newLot = {
            lotId: "",
            quantity: 0,
            timestamp: "",
            location: "",
            buyer: State.defaultClient == null ? "" : State.defaultClient,
            subLotIds: "",
          };

          setFormData({
            location: "",
            lotId: "",
            quantity: "",
            feedType: "",
            buyerInfo: State.defaultClient == null ? "" : State.defaultClient,
            date: new Date().toISOString().split("T")[0],
            toggle1: false,
            toggle2: false,
            toggle3: false,
            toggle4: false,
            toggle5: false,
            toggle6: false,
          });

          await wait(1000);
          const resp3 = await fetchLotEvents(newLotId);
          setTutorialSteps(submitedStep);
          setTutorialStep(0);
          console.log("=== resp3 === Step2Form.js === key: 330745 ===");
          console.dir(resp3, { depth: null, colors: true });
          console.log("=================================");
        }
      }
    } else {
      alert("Veuillez remplir tous les champs obligatoires.");
    }

    setIsSubmitting(false);
  };

  const isFormValid = () => {
    formData.convertedDate = new Date(formData.date).toISOString();
    if (isNaN(formData.quantity)) {
      formData.quantity = 1;
    }
    formData.quantity = parseInt(formData.quantity || 0);
    formData.location = formData.location
      .replace(/\s+/g, " ")
      .replace(/,+/g, ",")
      .replace(/\.+/g, ".")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");
    formData.lotId = formData.lotId
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");
    formData.feedType = formData.feedType
      .replace(/\s+/g, " ")
      .replace(/-+/g, "-")
      .replace(/[^\p{L}\p{N}\-., ]+/gu, "");
    formData.buyerInfo =
      State.defaultClient == null
        ? formData.buyerInfo
            .replace(/\s+/g, " ")
            .replace(/[^\p{L}\p{N}\-., ]+/gu, "")
        : State.defaultClient;

    return (
      formData.location &&
      formData.lotId &&
      formData.quantity &&
      formData.feedType &&
      formData.buyerInfo &&
      formData.date
    );
  };

  const CheckboxList = ({ items }) => {
    return (
      <div>
        {items.map((item, index) => (
          <div className="form-check custom-checkbox" key={"lot_" + index}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`lot${index + 1}`}
              name={`lot${index + 1}`}
              checked={formData[`lot${index + 1}`]}
              onChange={(e) => {
                let sl = [...subLots];
                if (e.target.checked) {
                  sl.push(item);
                } else {
                  sl.splice(sl.indexOf(item), 1);
                }
                sl = [...new Set(sl)];
                setSubLots(sl);
                handleChange(e);
              }}
            />
            <label className="form-check-label" htmlFor={`lot${index + 1}`}>
              {item}
            </label>
          </div>
        ))}
      </div>
    );
  };

  const SwitchesList = ({ items }) => {
    return (
      <div>
        {items.map((item, index) => (
          <div className="form-check form-switch" key={"toggle_" + index}>
            <input
              className="form-check-input"
              type="checkbox"
              id={`toggles${index + 1}`}
              name={`toggles${index + 1}`}
              checked={formData[`toggles${index + 1}`]}
              onChange={handleChange}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit} className="container form-2">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>
      {/* Affichage du popup tutoriel */}
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={tutorialSteps[tutorialStep].handleNextTutorialStep || handleNextTutorialStep}
          onClose={handleCloseTutorial}
          txUrl={txUrl}
          showArrow={tutorialSteps[tutorialStep].showArrow === true}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={(tutorialSteps[tutorialStep].id == "submitedStep" && lotsStock.length===0)?"hidden":tutorialSteps[tutorialStep].closeLabel}
        />
      )}
      <div className="fiels-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-switch-main">
            <div className="spacer"></div>
            <p className="form-switchs-label">Données confidentielles</p>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="date" className="form-label">
                Date d'envoi des volailles{" "}
              </label>
              <input
                type="date"
                className="form-control"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                placeholder="jj/mm/aaaa"
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                ref={dateInputRef}
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Date Icon"></img>
              </span>
            </div>
            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle1"
                name="toggle1"
                checked={formData.toggle1}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="location" className="form-label">
                Localisation de l'élevage{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="location"
                name="location"
                value={formData.location}
                onChange={handleChange}
                required
                placeholder="ex: Crupet, Belgique"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle2"
                name="toggle2"
                checked={formData.toggle2}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="lotId" className="form-label">
                Nom du lot de volailles{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="lotId"
                name="lotId"
                value={formData.lotId}
                onChange={handleChange}
                required
                placeholder="ex: Lot DEF456"
                maxLength={25}
              />

              <div className="lot-details">
                <div className="composition">
                  <p>Composition du lot</p>

                  <CheckboxList items={lotsStock} />
                </div>

                <div className="composition">
                  <p>Problème détecté</p>

                  <SwitchesList items={lotsStock} />
                </div>
              </div>
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle3"
                name="toggle3"
                checked={formData.toggle3}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="quantity" className="form-label">
                Quantité de volailles{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="quantity"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                required
                placeholder="ex: 500"
                maxLength={9}
              />
            </div>
            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle4"
                name="toggle4"
                checked={formData.toggle4}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="feedType" className="form-label">
                Type d’alimentation{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="feedType"
                name="feedType"
                value={formData.feedType}
                onChange={handleChange}
                required
                placeholder="ex: Aliment biologique"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle5"
                name="toggle5"
                checked={formData.toggle5}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field ">
              <label htmlFor="buyerInfo" className="form-label">
                Information acheteur{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="buyerInfo"
                name="buyerInfo"
                value={formData.buyerInfo}
                onChange={handleChange}
                required
                placeholder="ex: Entreprise ABC"
                maxLength={45}
              />
            </div>

            <div className=" form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="toggle6"
                name="toggle6"
                checked={formData.toggle6}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="btn-wrapper">
          {!isSubmitting ? (
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isFormValid() || subLots.length === 0}
            >
              Enregistrer le lot
            </button>
          ) : (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
            </div>
          )}
        </div>

        <div className="next-btn-wrapper">
          <button
            className="btn btn-primary"
            disabled={!currentLot || tutorialStep !== -1 || isSubmitting}
            onClick={(e) => {
              e.preventDefault();

              supplyChainNextStep(e);

              return;
            }}
          >
            {" "}
            Passer à l'étape suivante: l'abattoir{" "}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Step2Form;
